module.exports = __webpack_public_path__ + "img/Security3_JP@3x.c9db30a2.png";